import Render from './Overview/Render.es6';

(() => {
    class Overview extends App.Component {
        constructor(container) {
            super(container);
            App.Interface.Search.Observer.register(this);

            // @todo: change logic using "addRenderBlockingPromise"
            Promise.all([
                App.Endpoint.Offers.promise(),
                App.Endpoint.Products.promise(),
                App.Endpoint.Badges.get,
            ]).then(() => {
                this
                    .update()
                    .bind()
                ;
            });
        }

        /* Constants */
        get Interface()   { return App.Interface.Search }
        get data()        { return App.Interface.Search.get }
        get Render()      { return this._render || (this._render = new Render(this)) }
        get isQuickView() { return false }
        get isShop()      { return App.Variable('isShop') }

        visualUpdateEffect() {
            this.container.style.opacity = '0.7';
            setTimeout(() => this.container.style.opacity = '1', 100);
        }

        url(item) {
            let url = item.url;
            switch (item.type) {
                case 'product':
                    url = this.isQuickView ? App.Route('shop.product') + item.id : url;
                    break;
            }
            return url;
        }

        target(item) {
            let target = '_self';
            switch (item.type) {
                case 'product':
                    target = this.isQuickView && !this.isShop ? 'popup' : target;
                    break;
            }
            return target;
        }

        bind() {
            // Fix the control to the top
            new IntersectionObserver(
                ([e]) => {
                    e.target.classList.toggle('is-fixed', e.intersectionRatio < 1);
                    document.querySelectorAll('.mobile-filter-button-bottom')
                        .forEach(button => button.classList.toggle('active', e.intersectionRatio !== 1));
                },
                {threshold: [1]}
            ).observe(this.container.querySelector('.overview-control-placeholder'));

            window.addEventListener('scroll', () => {
                let timeout = setTimeout(() => {
                    sessionStorage.setItem('overview-scroll', window.scrollY);
                    clearInterval(timeout);
                }, 500);
            });
            return this;
        }

        apply() {
            this.container.querySelectorAll('.js-overview-total-counter')
                .forEach(e => e.innerHTML = App.Interface.Search.get.total);
            this.container.querySelectorAll('.js-overview-counter')
                .forEach(e => e.innerHTML = App.Interface.Search.get.count);
            this.container.querySelectorAll('.js-display-category')
                .forEach(e => e.innerHTML = App.Interface.Search.get.filter.featured ?
                    App.Interface.Search.Filter.getFeaturedFilter().label + ' ' : '');
            this.container.querySelectorAll('.js-overview-filter-count')
                .forEach(e => e.innerHTML = App.Interface.Search.get.filter.selected || '');
            this.container.classList.toggle('has-category', App.Interface.Search.get.filter.featured);
        }

        update() {
            super.update(() => {
                this.visualUpdateEffect();
                this.Render.update();
                this.apply();
                App.Layout.refresh();
                // Scroll to last known position
                const position = parseInt(sessionStorage.getItem('overview-scroll'));
                if (position) setTimeout(() => window.scrollTo(0, position), 500);
            });
            return this;
        }
    }
    App.Components.register('.overview', Overview);
})();
